import React, { useState, useEffect, useRef } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import "./style.css";
import { DatasetIndicatorProps } from "./DatasetIndicatorTypes";

export default function DatasetIndicator(props: DatasetIndicatorProps) {
  const urlEasas = props.customHost
    ? props.customHost
    : `${window.location.origin.toString() + window.contextRoot}`;

  const datasetEndpoint = "/rest/datasets/data/recent/";

  const ranges = props.ranges;

  const [segmentStops, setSegmentStops] = useState([]);
  const [colors, setColors] = useState([]);
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);
  const [datasetValue, setDatasetValue] = useState(-1);

  useEffect(() => {
    handleSetColors();
    handleMinMaxValues();
    handleSegmentStops();

    var tempUrl = new URL(urlEasas + datasetEndpoint + props.dataset_id);
    tempUrl.searchParams.append("count", 1); // Galbut kita skaiciu reikia naudoti
    tempUrl.searchParams.append(
      "referenceTime",
      new Date(Date.now()).toISOString()
    );

    var requestInit = {};
    var header = undefined;
    if (props.token) {
      header = new Headers({
        Authorization: "Bearer " + props.token,
        "Content-Type": "application/json",
      });
    } else {
      header = new Headers({
        "Content-Type": "application/json",
      });
    }
    if (props.customHost) {
      requestInit = {
        method: "GET",
        headers: header,
      };
    } else {
      requestInit = {
        method: "GET",
        credentials: "same-origin",
        headers: header,
      };
    }

    fetch(tempUrl, requestInit)
      .then((response) => {
        if (!response.ok) {
          throw `Bad response status code:${response.status}`;
        }
        return response.json();
      })
      .then((data) => {
        setDatasetValue(data[0].value.toFixed(2));
      })
      .catch(function (err) {
        console.log(
          "Error while Fetching data from server, error:" + err.message
        );
        setDatasetValue(0);
      });
  }, []);

  // Set colors
  const handleSetColors = () => {
    var colorsArr = [];
    ranges.forEach((value, i) => {
      colorsArr[i] = value.color;
    });
    setColors(colorsArr);
  };

  // Get min and max values
  const handleMinMaxValues = () => {
    var min = undefined;
    var max = undefined;
    for (var i = 0; i < ranges.length; i++) {
      if (min === undefined) {
        min = ranges[i].min;
      }
      if (max === undefined) {
        max = ranges[i].max;
      }
      if (min !== undefined && max !== undefined) {
        min = min > ranges[i].min ? ranges[i].min : min;
        max = max < ranges[i].max ? ranges[i].max : max;
      }
    }
    setMaxValue(max);
    setMinValue(min);
  };

  // Set arcs persentagemaxValue
  const handleSegmentStops = () => {
    var segmentStopsTemp = [];
    for (var i = 0; i < ranges.length; i++) {
      if (segmentStopsTemp.length === 0) {
        segmentStopsTemp.push(ranges[i].min);
        segmentStopsTemp.push(ranges[i].max);
      } else {
        segmentStopsTemp.push(ranges[i].max);
      }
    }
    setSegmentStops(segmentStopsTemp);
  };

  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (ref !== null) {
      setWidth(ref.current.offsetWidth);
      setHeight(ref.current.clientHeight);
    }
  }, []);

  return (
    <div ref={ref} style={{ width: "500px", height: "300px" }}>
    {/* <div ref={ref} style={{ width: "100%", height: "100%" }}> */}
      {segmentStops.length !== 0 && width && height && (
        <ReactSpeedometer
          className="center_speedometer"
          currentValueText={datasetValue + " " + props.dataset_unit}
          value={datasetValue}
          minValue={minValue}
          maxValue={maxValue}
          height={height && height < 300 ? 300 : height}
          //   height={height}
          width={width > 500 ? 500 : width}
          // width={width}
          segments={ranges.length}
          segmentColors={colors}
          arcsLength={0.3}
          ringWidth={60}
          customSegmentStops={segmentStops.map((val) => val)}
          needleColor={
            props.needleColor === undefined ? "#464A4F" : props.needleColor
          }
          needleHeightRatio={0.82}
        />
      )}
    </div>
  );
}
